module.exports = __webpack_public_path__ + "static/media/power-x-gym2.f2b9cbed.png";